import React from 'react';
import classNames from 'classnames';
import ChevronDownIcon from '../../common/components/Icons/ChevronDownIcon';

import './requirementsInfoAccordion.css';

const baseClassName = 'requirements-info-accordion';
const headerClassName = `${baseClassName}__header`;
const headerItemClassName = `${headerClassName}__item`;
const contentClassName = `${baseClassName}__content`;
const contentTextClassName = `${contentClassName}__text`;
const contentUlClassName = `${contentClassName}__ul`;
const contentStrongClassName = `${contentClassName}--strong`;

const RequirementsInfoAccordionContent = () => (
  <div className={contentClassName}>
    <p className={contentTextClassName}>
      We're committed to responsible gaming. To ensure a safe and fair lottery for everyone, we need to quickly and accurately verify your age, as it's a legal requirement to be 18 or older to play the New York Lottery.
    </p>
    <p className={contentTextClassName}>
      Rest assured, your information is protected:
    </p>
    <ul className={contentUlClassName}>
      <li className={contentTextClassName}><strong className={contentStrongClassName}>Verification Process</strong>: Age verification is handled securely by an independent third party.</li>
      <li className={contentTextClassName}><strong className={contentStrongClassName}>Data Protection</strong>: We do not store sensitive personal information once verification is complete.</li>
    </ul>
    <p className={contentTextClassName}>We appreciate your trust in the New York Lottery. Let's play!</p>
  </div>
)

const handleButtonClassName = `${headerClassName}__handle-button`;
const handleButtonContentClassName = `${handleButtonClassName}__content`;

const RequirementsInfoAccordion = () => {
  const [expandAccordion, setExpandAccordion] = React.useState(false);

  const toggleExpandAccordion = (event) => {
    event.preventDefault();
    setExpandAccordion((prevExpandAccordion) => !prevExpandAccordion);
  };

  return (
    <div className={baseClassName}>
      <div className={headerClassName}>
        <div className={`${headerItemClassName} ${headerItemClassName}--title`}>
          <h3 className={`${headerClassName}__title`}>Why do we require certain information for registration?</h3>
        </div>
        <div className={`${headerItemClassName} ${headerItemClassName}--handle`}>
          <button
            className={`btn btn-sm ${handleButtonClassName}`}
            type="button"
            onClick={toggleExpandAccordion}
          >
            <div
              className={
                classNames(
                  handleButtonContentClassName,
                  { [`${handleButtonContentClassName}--expanded`]: expandAccordion })
              }>
              <ChevronDownIcon />
            </div>
          </button>
        </div>
      </div>
      {expandAccordion ? (
        <RequirementsInfoAccordionContent />
      ) : null}
    </div>
  );
};

export default RequirementsInfoAccordion;
